import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
    disabled?: boolean;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-637" data-mp="1cjt1tzg9zhlr">
      {label && <label htmlFor={selectId} className="block text-sm font-semibold text-white mb-2" data-id="element-638" data-mp="1cizzdaocne9f">
          {label}
        </label>}
      <select id={selectId} className={`w-full px-4 py-3 bg-dark-surface text-white border-2 border-dark-border rounded-industrial focus:outline-none focus:border-brand-yellow transition-colors appearance-none cursor-pointer ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-639" data-mp="12m5553z4000y">
        {options.map(option => <option key={option.value + option.label} value={option.value} disabled={option.disabled} className={option.disabled ? 'text-gray-600' : ''} data-id="element-640" data-mp="31xy4v8da7jhd">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-500" role="alert" data-id="element-641" data-mp="1fj9dfptey2ib">
          {error}
        </p>}
    </div>;
}